var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395 40",
    width: 395,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,2) scale(0.5625)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#1F2A44"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 24,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22h11l9 9v9H32z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 25,
    width: 8,
    height: 7,
    rx: 1,
    fill: "#1F2A44"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 46,
    height: 4,
    fill: "#F28C28"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "#1F2A44",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 46,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 46,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 5
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 29,
    fontFamily: "Montserrat, Lato, Helvetica, Arial, sans-serif",
    fontSize: 26,
    fill: "#1F2A44"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 800
  }, "Truck"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 400,
    fill: "#F28C28"
  }, "Center"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bfe20e95441a2a6c0fc6911562edef82.svg";
export { ForwardRef as ReactComponent };